{
  "schema": "gridx.realtime-protocol",
  "version": 1,
  "redisPrefix": "gridx:realtime",
  "ticketTtlSeconds": 120,
  "internalAuthorizePath": "/internal/realtime/authorize",
  "socketPath": "/socket.io",
  "friendState": {
    "version": 2,
    "fields": [
      "friend_state_version",
      "id",
      "email",
      "display_name",
      "online",
      "on_trip",
      "precise",
      "trip_id",
      "lat",
      "lon",
      "speed",
      "heading",
      "accuracy",
      "elevation",
      "last_seen_at",
      "signal_lost",
      "signal_lost_at",
      "resting",
      "resting_at",
      "location_source",
      "location_recorded_at",
      "location_stale",
      "location_share_id",
      "location_share_expires_at",
      "track_last_point_at",
      "track_high_water_point_id",
      "presence_last_seen_at",
      "realtime_event_id",
      "realtime_received_at"
    ]
  },
  "tripState": {
    "defaultNotRecordingCode": "trip_not_recording",
    "finishReasonCodes": {
      "explicit": "trip_finished_explicitly",
      "abandoned": "trip_revivable_abandoned",
      "superseded": "trip_finished_superseded"
    },
    "terminalErrorCodes": [
      "trip_not_recording",
      "trip_finished_explicitly",
      "trip_finished_superseded",
      "trip_revivable_abandoned"
    ],
    "terminalControlEventTypes": [
      "trip_finished",
      "trip_destroyed"
    ],
    "controlEvents": {
      "trip_finished": "trip_finished",
      "trip_destroyed": "trip_destroyed",
      "friendship_revoked": "friendship_revoked",
      "trip_membership_revoked": "trip_membership_revoked",
      "live_point": "live_point"
    },
    "controlEventTypes": [
      "trip_finished",
      "trip_destroyed",
      "friendship_revoked",
      "trip_membership_revoked",
      "live_point"
    ]
  }
}
